export const DiscoverIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2ZM4 12a8 8 0 1 1 16 0 8 8 0 0 1-16 0Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.6 7.4a1 1 0 0 1 .264.932l-1.5 5.5a1 1 0 0 1-.696.696l-5.5 1.5a1 1 0 0 1-1.196-1.196l1.5-5.5a1 1 0 0 1 .696-.696l5.5-1.5A1 1 0 0 1 16.6 7.4ZM10.87 10.87l-.78 2.86 2.86-.78.78-2.86-2.86.78Z"
      fill="currentColor"
    />
  </svg>
);
